import { createContext } from 'react';
import { Listing } from 'models/Listing';
import utils from 'utils';

export type SaveFieldsOptions = {
  /** Buffer the change and flush one second after the last call. */
  debounce?: boolean;
  /**
   * Extra keys merged into local listing state only - never sent.
   * Mirrors `updatedValues` in PatchListingProvider.
   */
  listingPatch?: Partial<Listing>;
};

type PreviewPatchListingContextProps = {
  /** Keys may be dotted field names ('location.state'); values are form-shaped. */
  saveFields: (
    values: Record<string, any>,
    options?: SaveFieldsOptions,
  ) => void;
  /** Cancel the pending debounce and send the buffer now. */
  flushNow: () => void;
  /** File uploads save themselves - these only drive the indicator. */
  notifyUploadStart: () => void;
  notifyUploadSuccess: () => void;
  notifyUploadFailure: () => void;
};

export default createContext<Partial<PreviewPatchListingContextProps>>({
  saveFields: utils.noop,
  flushNow: utils.noop,
  notifyUploadStart: utils.noop,
  notifyUploadSuccess: utils.noop,
  notifyUploadFailure: utils.noop,
});
